import React from 'react';

const Chat: React.FC = () => (
  <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
    <h1 style={{ color: '#fff', marginBottom: '16px' }}>Chat</h1>
    <p style={{ color: '#9ca3af' }}>Conversations — wire to GET /chats and messages when ready.</p>
  </div>
);

export default Chat;
